export default __webpack_public_path__ + "static/media/dip_holding_flag.f26aac8f.png";